const norm = (s) => (s || "").toLowerCase();
const day = (iso) => (iso ? iso.slice(0, 10) : "");
const STOP = new Set(["the", "a", "an", "at", "in", "on", "for", "of", "to", "and", "job", "jobs"]);
const words = (s) => norm(s).split(/[^\p{L}\p{N}]+/u).filter((w) => w.length > 1 && !STOP.has(w));
const hasAll = (hay, phrase) => { const ws = words(phrase); return ws.length ? ws.every((w) => hay.includes(w)) : hay.includes(norm(phrase)); };

export const matchesFilters = (d, f) => {
  if (!f) return true;
  if (f.status?.length && !f.status.includes(d.status)) return false;
  const created = day(d.created_at);
  if (f.date_from && created < f.date_from) return false;
  if (f.date_to && created > f.date_to) return false;
  const hay = norm([d.title, d.task_summary, d.transcript, d.sender_name, d.properties?.title, d.recipient_name, d.recipient_phone, d.recipient_email, ...(d.tasks || []), ...(d.hazards || [])].join(" "));
  if (f.recipient && !hasAll(hay, f.recipient)) return false;
  if (f.site && !hasAll(norm([d.properties?.title, d.title, d.task_summary, d.transcript].join(" ")), f.site)) return false;
  if (f.keywords?.length && !f.keywords.some((k) => hasAll(hay, k))) return false;
  if (f.text && !hay.includes(norm(f.text))) return false;
  return true;
};

export const filterChips = (f) => {
  const chips = [];
  if (!f) return chips;
  if (f.status?.length) chips.push({ key: "status", label: `Status: ${f.status.join(", ")}` });
  if (f.date_from || f.date_to) chips.push({ key: "date", label: `${f.date_from || "…"} → ${f.date_to || "today"}` });
  if (f.recipient) chips.push({ key: "recipient", label: `For: ${f.recipient}` });
  if (f.site) chips.push({ key: "site", label: `Site: ${f.site}` });
  (f.keywords || []).forEach((k, i) => chips.push({ key: `kw:${i}`, label: k }));
  if (f.text) chips.push({ key: "text", label: `“${f.text}”` });
  return chips;
};

export const removeChip = (f, key) => {
  const n = { ...f };
  if (key === "status") delete n.status;
  else if (key === "date") { delete n.date_from; delete n.date_to; }
  else if (key.startsWith("kw:")) { n.keywords = (n.keywords || []).filter((_, i) => i !== Number(key.slice(3))); if (!n.keywords.length) delete n.keywords; }
  else delete n[key];
  return Object.keys(n).length ? n : null;
};
